<template>
  <v-card class="elevation-12">
    <v-alert
        v-if="alert.show"
        :type="alert.type"
        border="left"
    >
      {{ alert.text }}
    </v-alert>

    <v-card-title class="title font-weight-regular justify-space-between">
      <span>Bem Vindo(a)!</span>

      <v-progress-linear
          :active="loading"
          indeterminate
          rounded
      ></v-progress-linear>

    </v-card-title>


    <v-card-text>
      <v-form>
        <v-text-field
            v-model="form.email"
            label="Email"
            name="login"
            prepend-icon="mdi-account"
            type="text"
        ></v-text-field>

        <v-text-field
            v-model="form.pwd"
            id="password"
            label="Senha"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-on:click="login">Entrar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    form: {
      email: '',
      pwd: '',
    },

    alert: {
      type: '',
      show: '',
      text: '',
    },
    loading: false,
  }),

  mounted() {
    localStorage.removeItem('user');
  },

  methods: {
    login() {
      this.loading = true;

      axios.post(
          '/usuarios/login',
          this.form
      ).then((response) => {
        this.alert.type = 'success';
        this.alert.show = true;
        this.alert.text = 'Login feito. Redirecionando...';

        let user = response.data;

        if (user.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('user', JSON.stringify(user));

          this.$router.push({path: '/timeline'})
          // setTimeout(() => {
          //  this.$router.push({path: '/timeline'})
          // }, 500);
        }

      }, (error) => {
        this.alert.type = 'warning';
        this.alert.show = true;
        this.alert.text = error.response.data.msg || 'Tivemos um problema ao realizar o login';
      }).catch(error => {
        console.log(error)
        this.alert.type = 'error';
        this.alert.show = true;
        this.alert.text = 'Houve algum erro ao fazer login.';
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
